export default "__VITE_ASSET__BpgmdeEP__"